import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'footnotes',
    label: 'Footnotes',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
